import { IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip } from "@mui/material";
import { PencilIcon } from "@/toolbox/constants/icons";
import React from "react";
import { Popup } from "@/views/Editor/components/Popup";
import { Props } from "./ComprasTable.type";
import Paper from '@mui/material/Paper';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { ModalDetalle } from "../ModalDetalle";
import { compraService } from "@/service/services/Compra.service";
import { saveLocalStorage } from '@helpers/local-storage-helper';
import { KEY_EDIT_COMPRA, PRODUCTS_CARD, KEY_EDIT_COMPRA_ID, KEY_EDIT_COMPRA_PROVEEDOR_ID } from '@constants/local-storage';
import { ROUTE_NUEVA_COMPRA } from "@/toolbox/constants/route-map";
import { SendAndArchive } from '@mui/icons-material';
import { useHistory } from 'react-router-dom';
import { Loading } from "@/components/common/Loading";

export const ComprasTable: React.FC<Props> = (props:Props):JSX.Element => {

    const {compras, type, onListCompras} = props;

    const [loading,setLoading] = React.useState<boolean>(false);
    const [openPopup, setOpenPopup] = React.useState(false);
    const [compraSelected,setCompraSelect] = React.useState<number>(0);
    // eslint-disable-next-line
    const [showModalDelete, setShowModalDelete]= React.useState(false);

    const history = useHistory();

    const handleEditarCompra = async (idCompra: number, id_proveedor: number, razon_social: string, folio: number) => {
        if(idCompra){
            setLoading(true);
            await compraService.listByCompra(idCompra).then((data) =>{
                saveLocalStorage(KEY_EDIT_COMPRA_ID, idCompra);
                saveLocalStorage(KEY_EDIT_COMPRA_PROVEEDOR_ID, {
                  key: id_proveedor,
                  label: razon_social,
                  folio: folio,
                });
                saveLocalStorage(KEY_EDIT_COMPRA, data[0]);
                saveLocalStorage(PRODUCTS_CARD, data[1]);
            })

            setLoading(false);
            history.push(ROUTE_NUEVA_COMPRA);
        }
    }

    const closeModalDelete=()=>{
        setShowModalDelete(false);
    }

    const handleReceivedCompra = async(idCompra: number) => {
      if (idCompra) {
         setLoading(true);
         await compraService.receivedAt(idCompra).then((data) =>{
               if (data.status === 200) {
                  onListCompras();
               }
         })

         setLoading(false);
      }
    }


    return (
        <>
        {loading && <Loading/>}
        <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
            <TableRow >
                <TableCell>{`N°`}</TableCell>
                <TableCell align='center'>Folio</TableCell>
                <TableCell align='center'>Proveedor</TableCell>
                <TableCell align='center'>Fecha de registro</TableCell>
                {/* {
                   type === "compra" && <TableCell align='center'>Fecha de recepcion</TableCell>
                } */}
                <TableCell align='center'>Acciones</TableCell>
            </TableRow>
        </TableHead>
        <TableBody>
            {
                compras && compras.map((item, id) =>(
                    <TableRow key={id}>
                        <TableCell component="th" scope="row">
                            {id+1}
                        </TableCell>
                        <TableCell align='center' component="th" scope="row">
                            {item.folio}
                        </TableCell>
                        <TableCell align='center' component="th" scope="row">
                            {item?.proveedor?.razon_social || '---'}
                        </TableCell>
                        <TableCell align='center' component="th" scope="row">
                            {item.fecha}
                        </TableCell>
                        {/* {
                           type === "compra" && <TableCell align='center' component="th" scope="row">
                                 {item.received_at}
                           </TableCell>
                        } */}
                        <TableCell align='center'>
                            <IconButton aria-label="add to shopping cart" color="secondary" sx={{marginRight: '5px'}}
                                onClick={()=>{
                                setOpenPopup(true);
                                setCompraSelect(item.id);
                            }}
                            >
                                <VisibilityIcon/>
                            </IconButton>

                            {
                               type === "orden" && <Tooltip title="Editar">
                                 <IconButton aria-label="add to shopping cart" color="secondary" sx={{marginRight: '5px'}}
                                    onClick={()=>{
                                          handleEditarCompra(item.id || 0, item?.proveedor?.id || 0, item?.proveedor?.razon_social || "--", item.folio || 0)
                                    }}
                                    >
                                    <PencilIcon/>
                                 </IconButton>
                              </Tooltip>
                            }
                            {
                               type === "orden" && <Tooltip title="Pasar a compra">
                                 <IconButton aria-label="add to shopping cart" color="secondary" sx={{marginRight: '5px'}}
                                    onClick={()=>{
                                       handleReceivedCompra(item.id)
                                    }}
                                    >
                                    <SendAndArchive/>
                                 </IconButton>
                              </Tooltip>
                            }
                        </TableCell>
                    </TableRow>
                ))
            }
        </TableBody>
        </Table>
        { openPopup &&
                <Popup
                    largo="md"
                    title = 'Detalle de la Venta'
                    openPopup = {openPopup}
                    setOpenPopup = {setOpenPopup}
                >
                <ModalDetalle
                    closeModal={closeModalDelete}
                    compraId={compraSelected}
                />

            </Popup>
         }
        </TableContainer>
        </>
    );
}
